<script setup lang="ts">
defineProps<{ num: string; title: string }>()
</script>

<template>
  <div class="group relative overflow-hidden rounded-xl border border-slate-200 bg-white p-8 shadow-sm hover:shadow-lg transition-all duration-300 hover:-translate-y-1">
    <!-- Step number with modern styling -->
    <div class="flex items-center gap-4 mb-6">
      <div class="flex h-12 w-12 items-center justify-center rounded-full bg-gradient-to-br from-primary-main to-primary-dark font-bold text-white shadow-lg group-hover:scale-110 transition-transform duration-300">
        {{ num }}
      </div>
      <h3 class="text-xl font-bold text-slate-900 group-hover:text-primary-main transition-colors duration-200">
        {{ title }}
      </h3>
    </div>
    
    <!-- Content with better typography -->
    <div class="relative">
      <p class="text-slate-600 leading-relaxed text-base">
        <slot />
      </p>
      
      <!-- Decorative element -->
      <div class="absolute -bottom-2 -right-2 h-16 w-16 rounded-full bg-primary-main/5 opacity-0 group-hover:opacity-100 transition-opacity duration-500"></div>
    </div>
    
    <!-- Hover indicator -->
    <div class="absolute top-0 right-0 h-2 w-2 bg-primary-main rounded-full opacity-0 group-hover:opacity-100 transition-all duration-300 transform scale-0 group-hover:scale-100"></div>
  </div>
</template>
